import { SUBSCRIPTION_RETRY_INITIAL_DELAY_MS, SUBSCRIPTION_RETRY_MAX_DELAY_MS } from './constants';

/** Wait before resubscribing after `failures` failures in a row. */
export const getSubscriptionRetryDelayMs = (failures: number): number =>
  Math.min(SUBSCRIPTION_RETRY_INITIAL_DELAY_MS * 2 ** failures, SUBSCRIPTION_RETRY_MAX_DELAY_MS);
